module.exports = __webpack_public_path__ + "media/images/creator/home/zigzag-34cd8041b0cdc84c07bcc0f75d5f3a94.svg";